import React from "react";
import "./over.css";
import fotodees from "../../img/fotodees-groen.jpg";

export default function OverMij() {
  return (
    <section className="overmij-section">
      <div className="container">
        <div className="content">
          <div className="text">
            <h1>Over mij</h1>
            <p>
              Mijn naam is Dees (afkorting van Desiree), ben 67 jaar oud en ik
              werd ongeveer 15 jaar geleden gevraagd door een vriendin om mee te
              gaan naar een keramiek-workshop die op haar werk werd
              georganiseerd. Daar werd ik besmet met het klei-virus en dat is
              nooit meer over gegaan! Ik heb vervolgens een aantal jaren les
              gehad van Frans Thevis en verder heb ik een aantal workshops
              gedaan en veel filmpjes en video's bekeken op internet.
            </p>
            <p>
              Maar de allerbeste leerschool die ik heb gehad (en nog regelmatig
              heb) is toch wel de praktijk! Ik zou wel eens willen weten hoeveel
              kilo's klei ik in de afgelopen jaren gebruikt heb en hoeveel
              werkstukken daar uiteindelijk van overgebleven zijn! Ik leer nog
              dagelijks bij en het gebeurt écht nog wel eens dat er wat kapot
              springt in de oven!
            </p>
            <p>
              Sinds kort ben ik gepensioneerd en heb ik dus ook meer tijd om met
              mijn vingers in de klei te zitten. Daarnaast heb ik nu ook meer
              tijd om mijn kennis en kunde door te geven aan andere mensen (en
              deze zelfs te besmetten met het klei-virus). Daarom werd het ook
              tijd dat ik een échte website kreeg mét een echte naam.
            </p>
            <p>
              Dankzij Dylano en zijn mede-studenten (Jarne,Jarno,Kyano) kijk je
              nu naar mijn website en heb ik gekozen voor de atelier-naam:{" "}
              <strong>Keramiek met een knipoog</strong>. De reden dat ik voor
              deze naam koos is dat ik het allerliefste gekke, bontgekleurde,
              fantasie-beesten en bloemen maak en vooral niet iemand ben die
              Pietje-precies/ heel serieus werkt. Ik vind het leuk als mijn werk
              een glimlach bij de mensen oproept en vandaar de knipoog!
            </p>
            <p>
              Ik werk vanuit de kelder van mijn woning in Landgraaf, Zuid
              Limburg en heb daar plaats voor maximaal 6 deelnemers. Uiteraard
              word je voorzien van koffie en/of thee met wat lekkers. Als je een
              hele dag komt kleien gaan we tussen de middag lekker bij mij
              lunchen.
            </p>
          </div>
          <div className="photo">
            <img src={fotodees} alt="Dees Gardeniers" />
          </div>
        </div>
      </div>
    </section>
  );
}
